<!--
  `z-9999` DELETED, not replaced. It is not a key on this build and emitted nothing; the layer this
  scrim actually paints at is the `z-50` `AppShell.vue:14` passes in, which is what puts it under the
  mobile sidebar. Two z-index tokens on one element, one of them inert, is exactly the class of
  defect R1 exists to end.

  It is not given a §3.8 name because §3.8 has no rung for it: the ladder runs drawer (60) then
  backdrop (70), so `backdrop` is the MODAL's scrim and sits ABOVE a drawer. A mobile navigation
  drawer's own scrim has to sit below its drawer, and the scale cannot say that. Raised as a gap.
-->
<template>
  <div
    v-if="isMobileOpen"
    class="fixed inset-0 bg-gray-900/50 lg:hidden"
    @click="toggleMobileSidebar"
  ></div>
</template>

<script setup>
import { useSidebar } from '@/composables/useSidebar'
const { toggleMobileSidebar, isMobileOpen } = useSidebar()
</script>
